import { isNil, isEmptyString } from './utilities';

export default (config) => (value) => {
  const { allowFalsey, falseIsInvalid } = config;
  return (isNil(value) || isEmptyString(value) || (value === false) || (allowFalsey && value === 'false') || (falseIsInvalid && value === false) ? config.message : null);
};
